import {
  HoverableComponent,
  HoverableComponentTypeConfig,
} from 'components/common/HoverableComponent';
import { type Lightning } from '@lightningjs/sdk';

export default abstract class AbstractCarousel<
  TemplateSpec extends Lightning.Component.TemplateSpec = Lightning.Component.TemplateSpec,
  TypeConfig extends HoverableComponentTypeConfig = HoverableComponentTypeConfig,
> extends HoverableComponent<TemplateSpec, TypeConfig> {
  protected totalItemsWidth = 0;

  override _inactive() {
    super._inactive();

    this.transition('w' as any).removeAllListeners('finish');
    this.transition('w' as any).removeAllListeners('progress');
  }

  protected abstract getTotalItemsWidth(): number;

  protected scrollUpdate(scrollTo: number): void {
    // do nothing by default
  }

  protected getItemWidth(): number {
    return 0;
  }

  protected getBorderGap(): number {
    return 0;
  }

  protected getExpandedItemWidth(): number | null {
    return null;
  }

  protected useHighlightFocus(): boolean {
    return true;
  }

  protected getFirstItemMaxWidth(): number {
    return this.getItemWidth() + this.getBorderGap();
  }
}
